import { AppStatus } from '@/redux'
import { APIClient } from '@/services'
import { analytics } from '@/services/analytics/segment'
import { clearPulseStore } from '../store'
import { ReviewOrganisationModal, ReviewOrgSuccessModal } from '../components'

export function usePulseFlow({
  questions,
  answers,
  clearAnswers
}: {
  questions: { id: number }[]
  answers: APIClient.Pulse.AnswerData[]
  clearAnswers: () => void
}) {
  const submit = async () => {
    const payload: APIClient.Pulse.AnswerInfo[] = answers.map((a, idx) => ({
      question: questions[idx].id,
      ...a
    }))

    await APIClient.Pulse.answerManyQuestions(payload)
    clearPulseStore()
  }

  const finish = async () => {
    AppStatus.set('loading')
    await submit()
    analytics.track('review_complete')
    ReviewOrganisationModal.close()

    setTimeout(() => {
      AppStatus.set('done').then(() => {
        ReviewOrgSuccessModal.open()
      })
    }, 1000)
  }

  return { finish }
}
